import LayoutRenderer from "./LayoutRenderer";

function LayoutRendererOuter(props) {
  const {
    catalogPathInfo,
    layoutConfig,
    draggedItem,
    hoveredItemId,
    selectedItem,
    type,
    saveEditElement,
    handleOnDrop,
    device,
    handleClick,
    handleResizeStart,
    handleDragOver,
    handleDragStart,
    onClickElement,
    hoveredDirectItemId,
    setHoveredDirectItemId,
    multiSelectedItems,
    handleRightClick
  } = props;
  const path = catalogPathInfo?.path;

  const maybeWithPath = (extra) => (path ? { ...extra, path } : extra);

  const handleClickOnElement = (...args) => {
    handleClick(...args, maybeWithPath());
  };
  const handleRightClickOnElement = (...args) => {
    handleRightClick(...args, maybeWithPath());
  };

  const handleClickOnInsideElement = (element, info) => {
    onClickElement(element, { ...info, ...maybeWithPath() });
  };

  const handleDragStartInCatalog = (...args) => {
    handleDragStart(...args, maybeWithPath());
  };

  const handleDragOverInCatalog = (...args) => {
    handleDragOver(...args, maybeWithPath());
  };

  const handleResizeStartInCatalog = (...args) => {
    handleResizeStart(...args, maybeWithPath());
  };

  const saveConfigInline = (config, id) => {
    saveEditElement(config, id, maybeWithPath());
  };

  return (
    <LayoutRenderer
      layoutConfig={layoutConfig}
      draggedItem={draggedItem}
      hoveredItemId={hoveredItemId}
      selectedItem={selectedItem}
      type={type}
      saveConfigOfNode={saveConfigInline}
      handleOnDrop={handleOnDrop}
      onClickElement={handleClickOnInsideElement}
      handleResizeStart={handleResizeStartInCatalog}
      handleClick={handleClickOnElement}
      handleRightClick={handleRightClickOnElement}
      handleDragOver={handleDragOverInCatalog}
      handleDragStart={handleDragStartInCatalog}
      hoveredDirectItemId={hoveredDirectItemId}
      setHoveredDirectItemId={setHoveredDirectItemId}
      multiSelectedItems={multiSelectedItems}
      device={device}
    />
  );
}

export default LayoutRendererOuter;
